import client from "../../client";

const reqModal = async (func) => {
  try {
    const { status, data } = await func();
    if (status === 200) {
      return data;
    } else {
      return {
        status: false,
        msg: `request failed with code ${status}`,
      };
    }
  } catch (e) {
    return {
      status: false,
      msg: e.message,
    };
  }
};

export const postMsg = (body) => {
  return reqModal(() => client.post(`/contact`, body));
};

export const getRepoCount = (lang) => {
  return reqModal(() => client.get(`/lang-in-repo/${lang}`));
};
